// Annoyances card game data with rankings
export const ANNOYANCES_CARDS = [
  { id: 1, name: "Jerks",
    image: "/images/annoyances/annoyances_1.jpg", rank: 1 },
  { id: 2, name: "Hunger",
    image: "/images/annoyances/annoyances_2.jpg", rank: 2 },
  { id: 3, name: "Bad Tippers",
    image: "/images/annoyances/annoyances_3.jpg", rank: 3 },
  { id: 4, name: "Headaches",
    image: "/images/annoyances/annoyances_4.jpg", rank: 4 },
  { id: 5, name: "Stomach Ache",
    image: "/images/annoyances/annoyances_5.jpg", rank: 5 },
  { id: 6, name: "Lost Keys",
    image: "/images/annoyances/annoyances_6.jpg", rank: 6 },
  { id: 7, name: "Too Hot",
    image: "/images/annoyances/annoyances_7.jpg", rank: 7 },
  { id: 8, name: "Too Cold",
    image: "/images/annoyances/annoyances_8.jpg", rank: 8 },
  { id: 9, name: "Tired",
    image: "/images/annoyances/annoyances_9.jpg", rank: 9 },
  { id: 10, name: "Sad",
    image: "/images/annoyances/annoyances_10.jpg", rank: 10 },
  { id: 11, name: "Lost Wallet",
    image: "/images/annoyances/annoyances_11.jpg", rank: 11 },
  { id: 12, name: "Lost Phone",
    image: "/images/annoyances/annoyances_12.jpg", rank: 12 },
  { id: 13, name: "Interruptions",
    image: "/images/annoyances/annoyances_13.jpg", rank: 13 },
  { id: 14, name: "Deadlines",
    image: "/images/annoyances/annoyances_14.jpg", rank: 14 },
  { id: 15, name: "Allergies",
    image: "/images/annoyances/annoyances_15.jpg", rank: 15 },
  { id: 16, name: "Bad Drivers",
    image: "/images/annoyances/annoyances_16.jpg", rank: 16 },
  { id: 17, name: "Mean People",
    image: "/images/annoyances/annoyances_17.jpg", rank: 17 },
  { id: 18, name: "The Unfunny",
    image: "/images/annoyances/annoyances_18.jpg", rank: 18 },
  { id: 19, name: "Terrible TV",
    image: "/images/annoyances/annoyances_19.jpg", rank: 19 },
  { id: 20, name: "Terrible Movies",
    image: "/images/annoyances/annoyances_20.jpg", rank: 20 },
  { id: 21, name: "Getting Lost",
    image: "/images/annoyances/annoyances_21.jpg", rank: 21 },
  { id: 22, name: "Flies",
    image: "/images/annoyances/annoyances_22.jpg", rank: 22 },
  { id: 23, name: "Mosquitoes",
    image: "/images/annoyances/annoyances_23.jpg", rank: 23 },
  { id: 24, name: "Travel Delays",
    image: "/images/annoyances/annoyances_24.jpg", rank: 24 },
  { id: 25, name: "Mortality",
    image: "/images/annoyances/annoyances_25.jpg", rank: 25 },
  { id: 26, name: "Obnoxious People",
    image: "/images/annoyances/annoyances_26.jpg", rank: 26 },
  { id: 27, name: "Close Talkers",
    image: "/images/annoyances/annoyances_27.jpg", rank: 27 },
  { id: 28, name: "Aging",
    image: "/images/annoyances/annoyances_28.jpg", rank: 28 },
  { id: 29, name: "Spam Messages",
    image: "/images/annoyances/annoyances_29.jpg", rank: 29 },
  { id: 30, name: "Dead Batteries",
    image: "/images/annoyances/annoyances_30.jpg", rank: 30 }
];
